import React from 'react';

const TermsOfService = () => (
  <div className="max-w-3xl mx-auto p-8">
    <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
    <p className="mb-4">
      By using Tailrd, you agree to use the service lawfully and not misuse user data. We reserve the right to suspend accounts for abuse or illegal activity.
    </p>
    <p>
      For questions, contact us at <a href="mailto:support@tailrd.com" className="text-blue-600 underline">support@tailrd.com</a>.
    </p>
  </div>
);

export default TermsOfService;
